module.exports = __webpack_public_path__ + "static/media/new-survy-icon.b9d8cbbb.svg";